import { ICollectionsListFilter, ILaunchpadsFilter, IUsersListFilter } from '@tacans/shared-marketplace-layer';
import { IReferralsFilters } from '@tacans/shared-marketplace-layer/dist/api/referral/referral.types';
import { useTranslation } from 'next-i18next';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNotifications } from 'src/services/notifications/use-notifications';
import { SearchInput } from 'src/ui/common/molecules/search-input';
import { IExploreFilters } from '../../ducks/explore-nfts/explore-nfts.types';

interface IExploreSearch {
    placeholder?: string;
    filters: IExploreFilters | ICollectionsListFilter | IUsersListFilter | ILaunchpadsFilter | IReferralsFilters;
    setFilters: (
        filters: IExploreFilters | ICollectionsListFilter | IUsersListFilter | ILaunchpadsFilter | IReferralsFilters
    ) => any;
}

export const ExploreSearch = ({ placeholder, filters, setFilters }: IExploreSearch) => {
    const { t } = useTranslation(['components', 'common']);
    const [searchValue, setSearchValue] = useState('');
    const { error: errorNotification } = useNotifications();
    const locale = useMemo(
        () => ({
            placeholder: t('exploreFilter.filter.search.label', { ns: 'components' }),
        }),
        [t]
    );

    const submit = useCallback(() => {
        if (filters.keywords !== searchValue && searchValue.trim().length !== 1) {
            setFilters({
                ...filters,
                keywords: searchValue,
            });
        }
        if (searchValue.trim().length === 1) {
            errorNotification({ text: t('messages.minimumSearchQuery', { ns: 'common', min: 2 }) });
        }
    }, [filters, searchValue, setFilters, errorNotification, t]);

    const onChange = useCallback((e) => {
        setSearchValue(e.target.value);
    }, []);

    const onClear = useCallback(() => {
        setSearchValue('');
        setFilters({
            ...filters,
            keywords: '',
        });
    }, [setFilters, filters]);

    useEffect(() => {
        setSearchValue('');
        filters.keywords && setSearchValue(filters.keywords);
    }, [filters?.keywords]);

    return (
        <SearchInput
            placeholder={placeholder ?? locale.placeholder}
            onChange={onChange}
            value={searchValue}
            onBlur={submit}
            onClear={onClear}
            onSubmit={submit}
        />
    );
};